export enum FIRESTORE_COLLECTIONS {
  USERS = "users",
  ORGANIZATIONS = "organizations",
}

export enum FIRESTORE_USER_SUB_COLLECTIONS {
  SAVED_FILTERS = "Saved Filters",
}

export enum FIRESTORE_ORGANIZATION_SUB_COLLECTIONS {
  DOMAIN_SETTINGS = "domain_settings",
}
